import React, { PureComponent } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import BlockCustom from './BlockCustom';

import './block-content.scss';

class BlockBordered extends PureComponent {
  render() {
    return (
      <div className={cn('block-data', this.props.type)}>
        <div className="block-value">
          <span dangerouslySetInnerHTML={{ __html: this.props.value}} />
          <span dangerouslySetInnerHTML={{ __html: this.props.unit}} />
        </div>

        <div
          className="block-text"
          dangerouslySetInnerHTML={{ __html: this.props.text}}
        />
      </div>
    );
  }
}

class BlockFilled extends PureComponent {
  render() {
    return (
      <div className={cn('block-data', this.props.type)}>
        {(this.props.value) &&
        <div className="block-value">
          <span dangerouslySetInnerHTML={{ __html: this.props.value}} />

          {(this.props.unit) &&
            <span dangerouslySetInnerHTML={{ __html: this.props.unit}} />
          }
        </div>
        }

        <div
          className="block-text"
          dangerouslySetInnerHTML={{ __html: this.props.text}}
        />
      </div>
    );
  }
}

class BlockSimple extends PureComponent {
  render() {
    return (
      <div className={cn('block-data', this.props.type)}>
        <div
          className="block-text"
          dangerouslySetInnerHTML={{__html: this.props.text}}
        />
      </div>
    );
  }
}

class Block extends PureComponent {
  render() {
    const blocks = {
      bordered: BlockBordered,
      filled: BlockFilled,
      simple: BlockSimple
    };

    const BlockType = blocks[this.props.type] || BlockCustom;

    return <BlockType {...this.props}/>;
  }
}

Block.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string,
  text: PropTypes.string.isRequired
};

export default Block;



// WEBPACK FOOTER //
// ./src/components/SuccessStory/BlockContent.js